import { TrendChip } from "./TrendChip";

/**
 * Dense, branded admin metric tile.
 *
 * Props:
 *   icon         lucide-react element (already sized 18)
 *   title        string, primary card title (e.g. "Active Patients")
 *   value        number, the headline metric
 *   subLabel     string, fine-print sub-line below the title (e.g. "Database total: 522")
 *   delta        number | null, signed change over the trend window
 *   deltaLabel   string, trend chip suffix (e.g. "this month")
 *   testIdRoot   string, used for both the wrapper and the value's data-testid
 *   onClick      fn, optional , makes the whole tile a button shortcut
 */
export const StatTile = ({
  icon,
  title,
  value = 0,
  subLabel,
  delta = null,
  deltaLabel = "this month",
  testIdRoot = "stat-tile",
  onClick,
}) => {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`relative flex flex-col p-5 bg-white rounded-2xl border border-[var(--light-border)] shadow-sm text-left transition-all ${
        onClick
          ? "hover:shadow-md hover:border-[var(--charcoal)]/30 hover:-translate-y-0.5"
          : ""
      }`}
      data-testid={testIdRoot}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="p-2.5 bg-[var(--bone-soft)] rounded-xl text-[var(--charcoal)] flex items-center justify-center">
          {icon}
        </div>
        {delta !== null && delta !== undefined && (
          <TrendChip
            delta={delta}
            label={deltaLabel}
            testId={`${testIdRoot}-trend`}
          />
        )}
      </div>
      <p
        className="text-4xl font-['Outfit'] font-bold tracking-tight text-[var(--dark-bg)] leading-none mb-2"
        data-testid={`${testIdRoot}-value`}
      >
        {value}
      </p>
      <p className="text-sm font-semibold text-[var(--charcoal)] mb-1">
        {title}
      </p>
      {subLabel && (
        <p className="text-xs text-[var(--text-muted)]">{subLabel}</p>
      )}
    </Tag>
  );
};

export default StatTile;
